<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="">{{ "common.home" | translate }}</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      {{ "common.pos" | translate }}
    </li>
    <li class="breadcrumb-item active">
      {{ getCommercialName() }}
      &nbsp;

      <span *ngIf="showDD()" class="badge badge-pill badge-success">DD</span>

      <span *ngIf="showID()" class="badge badge-pill badge-primary">ID</span>
    </li>
    <li class="ml-auto" *ngIf="!editMode">
      <a
        href="javascript:void(0)"
        class="btn btn-sm btn-primary px-4"
        (click)="riseEdit()"
        *ngIf="showEdit"
        ><img src="assets/img/icon-edit.svg" class="mx-1" />
        {{ "pos.actions.edit" | translate }}</a
      >
    </li>
    <li class="ml-auto" *ngIf="editMode">
      <a
        href="javascript:void(0)"
        class="btn btn-sm btn-primary px-4"
        (click)="riseSave()"
        ><img src="assets/img/icon-guardar.svg" class="mx-1" />
        {{ "pos.actions.save" | translate }}</a
      >
      <a
        href="javascript:void(0)"
        class="btn btn-sm btn-validar px-4 mx-2"
        (click)="riseValidate()"
        ><img src="assets/img/icon-validar.svg" class="mx-1" />
        {{ "pos.actions.validate" | translate }}</a
      >
      <a
        href="javascript:void(0)"
        class="btn btn-sm btn-cancelar px-4"
        (click)="riseCancel()"
        ><img src="assets/img/icon-cancelar.svg" class="mx-1" />
        {{ "pos.actions.cancel" | translate }}</a
      >
    </li>
  </ol>
</nav>
